import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { Sticker, Check } from 'lucide-react';

const MAX_STICKERS = 3;

export const StickerToggle = ({ formData, setFormData }) => (
  <div className="grid gap-2">
    <Label>Sticker Required</Label>
    <div className="flex items-center gap-2 pt-2">
      <Switch
        checked={!!formData.sticker_required}
        onCheckedChange={(checked) => setFormData({ ...formData, sticker_required: checked, sticker_ids: checked ? (formData.sticker_ids || []) : [] })}
        data-testid="sticker-required-toggle"
      />
      <span className="text-sm text-zinc-600">{formData.sticker_required ? 'Yes' : 'No'}</span>
    </div>
  </div>
);

export const StickerPicker = ({ stickers, formData, setFormData }) => {
  if (!formData.sticker_required) return null;
  const selected = formData.sticker_ids || [];
  const toggle = (id) => {
    if (selected.includes(id)) setFormData({ ...formData, sticker_ids: selected.filter(s => s !== id) });
    else if (selected.length < MAX_STICKERS) setFormData({ ...formData, sticker_ids: [...selected, id] });
  };
  return (
    <div className="p-3 border border-purple-200 bg-purple-50/50" data-testid="sticker-picker">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-bold uppercase tracking-wider text-purple-700">Choose stickers (up to {MAX_STICKERS})</span>
        <span className="text-xs text-purple-700" data-testid="sticker-picker-count">{selected.length}/{MAX_STICKERS} selected</span>
      </div>
      {stickers.length === 0 ? (
        <p className="text-xs text-gray-500" data-testid="sticker-picker-empty">No stickers set up yet. Add them in Settings › Categories › Sticker Type.</p>
      ) : (
        <div className="flex flex-wrap gap-2">
          {stickers.map(s => {
            const on = selected.includes(s.id);
            const disabled = !on && selected.length >= MAX_STICKERS;
            return (
              <button type="button" key={s.id} onClick={() => toggle(s.id)} disabled={disabled}
                className={`flex items-center gap-1 px-2.5 py-1 text-xs font-medium border transition-colors ${on ? 'bg-purple-700 text-white border-purple-700' : 'bg-white text-gray-700 border-gray-300 hover:border-purple-400'} disabled:opacity-40 disabled:cursor-not-allowed`}
                data-testid={`sticker-option-${s.id}`}>
                {on ? <Check className="w-3 h-3" /> : <Sticker className="w-3 h-3" />}{s.name}
              </button>
            );
          })}
        </div>
      )}
      {selected.length === 0 && stickers.length > 0 && <p className="text-xs text-red-600 mt-2" data-testid="sticker-picker-error">Choose at least one sticker, or turn off Sticker Required.</p>}
    </div>
  );
};

export const StickerLine = ({ stickers, testId, className = '' }) => {
  if (!stickers?.length) return null;
  return (
    <div className={`flex items-center gap-2 px-3 py-1.5 bg-purple-700 text-white rounded text-xs font-bold tracking-wide ${className}`} data-testid={testId || 'sticker-line'}>
      <Sticker className="w-3.5 h-3.5 shrink-0" />
      <span>STICKERS: {stickers.join(' · ')}</span>
    </div>
  );
};
